import { Flex } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { DateLeg } from "./DateLeg";
import { joinPath } from "./paths";

type CustomRangeBodyProps = {
  valuesPath: string;
  isReadOnly?: boolean;
};

/** Body for `CUSTOM` + `RANGE` — Start/End legs side-by-side. */
export const CustomRangeBody = ({ valuesPath, isReadOnly = false }: CustomRangeBodyProps) => (
  <Flex gap={SPACING.MEDIUM} alignItems="flex-start">
    <DateLeg
      legLabel="Start date"
      parameterName={joinPath(valuesPath, "customStartParameter")}
      dateName={joinPath(valuesPath, "customStartDate")}
      isReadOnly={isReadOnly}
    />
    <DateLeg
      legLabel="End date"
      parameterName={joinPath(valuesPath, "customEndParameter")}
      dateName={joinPath(valuesPath, "customEndDate")}
      isReadOnly={isReadOnly}
    />
  </Flex>
);
